import styled from '@emotion/styled';
import { Route, Routes } from 'react-router-dom';
import ApprovalPage from './Components/FormComponents/ApprovalPage';
import { FormProvider } from './Components/FormComponents/FormContext';
import MainPage from './Components/FormComponents/MainPage';
import Sidebar from './Components/FormComponents/Sidebar';
import SuccessPage from './Components/FormComponents/SuccessPage';
import PermissionRoute from './Components/PermissionRoute';
import Unauthorized from './Components/Unauthorized';
import Test from './Components/test';

const PageWrapper = styled.div`
  padding: 40px;
  padding-left: 310px; /* Matches Sidebar width */
  background-color: #f7fbff;
  min-height: 100vh;

  @media (max-width: 1024px) {
    padding-left: 210;
  }

  @media (max-width: 768px) {
    padding-left: 180px;
  }

  @media (max-width: 480px) {
    padding: 20px 20px 20px 140px;
  }
`;



const AppRouter = () => {

  return (
    // <Router>
    <FormProvider>
          <Routes>
              <Route path='/test' element={<Test />} />

              <Route
                  path='/*'
                  element={
                      <div style={{ minHeight: '100vh' }}>
                          <Sidebar />
                          <PageWrapper>
                              <MainPage />
                          </PageWrapper>
                      </div>
                  }
              />

              <Route path='/customers/success' element={<SuccessPage />} />

              <Route
                  path='/customers/approval'
                  element={
                      <PermissionRoute permission="manage_customers">
                          <div style={{ minHeight: '100vh', backgroundColor: '#f7fbff' }}>
                              <ApprovalPage />
                          </div>
                      </PermissionRoute>
                  }
              />

              <Route path='/Unauthorized' element={<Unauthorized />} />
          </Routes>

    </FormProvider>
    // </Router>
  );
};

export default AppRouter;
